<template>
  <div class="tla-form-group tla-form-group--margin-medium" v-if="showVistedDealership">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="visistedDealershipLabel"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'visitedDealership'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @visitedDealership="submitVisitedDealership($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('visitedDealership', 'message')">
      Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import GenericTouchpointComponent from '../ui/GenericTouchPointComponent.vue';
import Touchpoint from '../../models/Touchpoint';
import ExtraData from '../../models/ExtraData';
import PurchaseTime from '../../enums/PurchaseTime';

@Component({
  components: {
  touchpoint: GenericTouchpointComponent
  }
  })
export default class VisitedDealershipComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Have you already visited a dealership? <span>*</span>' })
  public visistedDealershipLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public showIfASAP!: boolean;

  public options: Touchpoint[] = [
    new Touchpoint('true', 'Yes'),
    new Touchpoint('false', 'No')
  ];

  public get purchaseTime(): PurchaseTime {
    return this.$store.getters['enquiryModule/purchaseTime'];
  }

  public get showVistedDealership(): boolean {
    return (this.purchaseTime === PurchaseTime.Asap && this.showIfASAP) || !this.showIfASAP;
  }

  public submitVisitedDealership(value: string) {
    const extraData = new ExtraData('visitedDealership', value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }
}
</script>
